import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthMaxAgeInputComponent } from "./auth-max-age-input/auth-max-age-input.component";
import { CertificateInputComponent } from "./certificate-input/certificate-input.component";
import { CheckboxInputComponent } from "./checkbox-input/checkbox-input.component";
import { CheckboxListComponent } from "./checkbox-list/checkbox-list.component";
import { DateInputComponent } from "./date-input/date-input.component";
import { EmailDomainInputComponent } from "./email-domain-input/email-domain-input.component";
import { FileInputComponent } from "./file-input/file-input.component";
import { FilterSelectInputComponent } from "./filter-select-input/filter-select-input.component";
import { ListInputComponent } from "./list-input/list-input.component";
import { OtpInputComponent } from "./otp-input/otp-input.component";
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { ItiPhoneInputDirective } from './phone-input/iti-phone-input.directive';
import { RadioListComponent } from "./radio-list/radio-list.component";
import { SelectInputComponent } from "./select-input/select-input.component";
import { TextInputComponent } from "./text-input/text-input.component";
import { RealmSelectInputComponent } from './realm-select-input/realm-select-input.component';
import { NgMatModule } from '../material';


/**
 * A module providing a phone number input and processing.
 *
 * Requires the following optional peer dependencies:
 * • intl-tel-input
 */
@NgModule({
  declarations: [
    AuthMaxAgeInputComponent,
    CertificateInputComponent,
    CheckboxInputComponent,
    CheckboxListComponent,
    DateInputComponent,
    EmailDomainInputComponent,
    FileInputComponent,
    FilterSelectInputComponent,
    ListInputComponent,
    OtpInputComponent,
    PhoneInputComponent,
    ItiPhoneInputDirective,
    RadioListComponent,
    RealmSelectInputComponent,
    SelectInputComponent,
    TextInputComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgMatModule,
  ],
  exports: [
    AuthMaxAgeInputComponent,
    CertificateInputComponent,
    CheckboxInputComponent,
    CheckboxListComponent,
    DateInputComponent,
    EmailDomainInputComponent,
    FileInputComponent,
    FilterSelectInputComponent,
    ListInputComponent,
    OtpInputComponent,
    PhoneInputComponent,
    RadioListComponent,
    RealmSelectInputComponent,
    SelectInputComponent,
    TextInputComponent,
  ]
})
export class AppFormsModule { }
